import type { CreateUserRequest, UserDetailed } from '@clsplus/api-types/api-admin'

import { getTokens } from '../../helpers/auth'

export function createUserDetails(formData: CreateUserRequest): Promise<UserDetailed> {
  const tokens = getTokens()
  return fetch(`${import.meta.env.VITE_API_URL}admin/users`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${tokens?.accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw new Error(data.error)
      }

      return data
    })
}
